// jQuery(document).ready(function($){
//   $(".banner_slider .banner_list").slick({
//     dots: false,
//     infinite: true,
//     arrows: true,
//     autoplaySpeed: 1000,
//     slidesToShow: 1,
//     adaptiveHeight: true,
//   });

//   $(".announcement-slider .announcement-list").slick({
//     dots: false,
//     infinite: true,
//     arrows: true,
//     autoplay: true,
//     autoplaySpeed: 2000,
//     slidesToShow: 1,
//   });

//    $('.featured-pro-slider').slick({
//     dots: false,
//     infinite: true,
//     autoplaySpeed: 300,
//     slidesToShow: 4,
//     slidesToScroll: 1,
//     responsive: [
//       {
//         breakpoint: 1025,
//         settings: {
//           slidesToShow: 3,
//           slidesToScroll: 1
//         }
//       },
//       {
//         breakpoint: 768,
//         settings: {
//           slidesToShow: 2,
//           slidesToScroll: 1,
//         }
//       },
//       {
//         breakpoint: 550,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1
//         }
//       }
//     ]
//   });
//    $('.insta-section .insta-row').slick({
//     dots: false,
//     arrows: false,
//     infinite: true,
//     slidesToShow: 5,
//     slidesToScroll: 3,
//     centerMode: true,
//     centerPadding: '100px',
//     responsive: [
//       {
//         breakpoint: 1367,
//         settings: {
//           slidesToShow: 4
//         }
//       },
//       {
//         breakpoint: 1025,
//         settings: {
//           slidesToShow: 3
//         }
//       },
//       {
//         breakpoint: 768,
//         settings: {
//           slidesToShow: 3,
//           centerPadding: '0px',
//         }
//       }
//     ]
//   });

//   $('.reviews-slider').slick({
//     dots: false,
//     infinite: true,
//     slidesToShow: 1,
//     slidesToScroll: 1
//   });
 
  
// });



// // tabbed content
// // http://www.entheosweb.com/tutorials/css/tabs.asp
// $(".tab-container .tab_content").hide();
// // $(".tab-container .tab_content:first").show();
// $('.tab-container').each(function(k,v){
//   $(v).find('.tab_content:first').show();
// });

// /* if in tab mode */
// $("ul.tabs li").click(function() {
//   var parent = $(this).parents('.tab-container');

//   $(parent).find(".tab_content").hide();
//   var activeTab = $(this).attr("rel");
//   $(parent).find("#"+activeTab).fadeIn();

//   $(parent).find("ul.tabs li").removeClass("active");
//   $(this).addClass("active");

//   $(parent).find(".tab_drawer_heading").removeClass("d_active");
//   $(parent).find(".tab_drawer_heading[rel^='"+activeTab+"']").addClass("d_active");

//   $('.products-slider-section .product-slider').slick('refresh');
  
// });
// /* if in drawer mode */
// $(".tab_drawer_heading").click(function() {
//   var parent = $(this).parents('.tab-container');

//   $(parent).find(".tab_content").hide();
//   var d_activeTab = $(this).attr("rel");
//   $(parent).find("#"+d_activeTab).fadeIn();

//   $(parent).find(".tab_drawer_heading").removeClass("d_active");
//   $(this).addClass("d_active");

//   $(parent).find("ul.tabs li").removeClass("active");
//   $(parent).find("ul.tabs li[rel^='"+d_activeTab+"']").addClass("active");
  
//   $('.products-slider-section .product-slider').slick('refresh');
  
// });

// $(document).on('click','.select-label', function () {
//     if($(this).parent().hasClass('active')){
//       $(this).parent().removeClass('active');
//     }else{
//       $('.dropdown').removeClass('active');
//       $(this).parent().addClass('active');
//     }
// });
// $(document).on('click','.dropdown-list li', function () {
//     $(this).parents('.dropdown').find('.select-label_inner').text($(this).text());
//     $(this).parents('.dropdown').removeClass('active');
//     var variant_id = $(this).data('value');
//     $(this).parents('.main_variant_div').parent().find('.product-variant-id').val(variant_id);
// });

//  function reorderDiv() {
//     const class1 = document.querySelector('.banner_slider');
//     const class3 = document.querySelector('.categories-small-sec');
//     if (window.innerWidth < 768) {
//       // Move class-3 before banner_slider
//       class1 ? class1.parentNode.insertBefore(class3, class1) : '';
//     } else {
//       // Reset order: put class-3 back after announcement-slider
//       const class2 = document.querySelector('.announcement-slider');
//       class2 ? class2.parentNode.insertBefore(class3, class2.nextSibling) : '';
//     }
//   }

//   // Run on load
//   reorderDiv();

//   // Run on resize
//   window.addEventListener('resize', reorderDiv);




// $(document).ready(function() {
//   // if ($(window).width() > 749) {
//   //   $('.product__media-wrapper .product__media-list').slick({
//   //     slidesToShow: 1,
//   //     slidesToScroll: 1,
//   //     arrows: false,
//   //     fade: true,
//   //     asNavFor: '.product-media-thumbnail-slide'
//   //   });
//   //   $('.product__media-wrapper .product-media-thumbnail-slide').slick({
//   //     slidesToShow: 5,
//   //     slidesToScroll: 1,
//   //     vertical: true,
//   //     asNavFor: '.product__media-list',
//   //     dots: false,
//   //     arrows: true,
//   //     focusOnSelect: true,
//   //     verticalSwiping:true
//   //   });
//   // } else {
//   //   $('.product__media-wrapper .product__media-list').slick({
//   //     slidesToShow: 1,
//   //     slidesToScroll: 1,
//   //     arrows: true,
//   //     fade: false,
//   //     dots: true
//   //   });
//   // }
// });


// $(".jdgm-preview-badge").click(function(e) {
//     e.preventDefault();
//     $('.product__accordion_review summary').trigger('click');
// });

// product__accordion working smooth start
document.addEventListener("DOMContentLoaded", function () {
  const accordions = document.querySelectorAll(".product__accordion details");

  accordions.forEach((detail) => {
    const summary = detail.querySelector("summary");
    const content = Array.from(detail.children).find(el => el.tagName !== "SUMMARY");

    if (content) {
      content.style.overflow = "hidden";
      content.style.height = "0px";
      content.style.transition = "height 0.3s ease";
    }

    summary.addEventListener("click", (e) => {
      e.preventDefault();

      if (detail.hasAttribute("open")) {
        closeAccordion(detail, content);
      } else {
        accordions.forEach((other) => {
          if (other !== detail) closeAccordion(other, Array.from(other.children).find(el => el.tagName !== "SUMMARY"));
        });
        openAccordion(detail, content);
      }
    });
  });

  function openAccordion(detail, content) {
    detail.setAttribute("open", "");
    requestAnimationFrame(() => {
      content.style.height = content.scrollHeight + "px";
    });
  }

  function closeAccordion(detail, content) {
    if (!detail.hasAttribute("open")) return;
    content.style.height = content.scrollHeight + "px";
    requestAnimationFrame(() => {
      content.style.height = "0px";
    });
    detail.removeAttribute("open");
  }
});
// product__accordion working smooth end


document.addEventListener("DOMContentLoaded", function() {
  function moveIcons() {
    const icons = document.querySelector(".icon-with-text");
    const firstAccordion = document.querySelector(".product__accordion");

    if (window.innerWidth < 749) {
      if (icons && firstAccordion && !firstAccordion.previousElementSibling?.classList.contains("icon-with-text")) {
        firstAccordion.parentNode.insertBefore(icons, firstAccordion);
      }
    } else {
      // Optional: move it back after accordions when resizing above 749px
      const lastAccordion = document.querySelectorAll(".product__accordion");
      if (lastAccordion.length && icons) {
        lastAccordion[lastAccordion.length - 1].after(icons);
      }
    }
  }

  // Run on load
  moveIcons();

  // Run on resize
  window.addEventListener("resize", moveIcons);
});
// footer accordions
  document.addEventListener("DOMContentLoaded", function() {
  const headings = document.querySelectorAll(".footer-block__heading");

// Open the first footer accordion by default (mobile only)
  if (window.innerWidth <= 640) {
    const firstCol = document.querySelector(".footer-col");
    if (firstCol) {
      firstCol.classList.add("active");
    }
  }

  headings.forEach(heading => {
    heading.addEventListener("click", function() {
      if (window.innerWidth <= 640) {
        const parent = heading.closest(".footer-col");

        // Close all other accordions
        document.querySelectorAll(".footer-col").forEach(col => {
          if (col !== parent) col.classList.remove("active");
        });

        // Toggle current
        parent.classList.toggle("active");
      }
    });
  });
});
